import React, { useEffect, useState } from 'react'
import useAxiosInstance from '../../hooks/useAxios';
import { TableCustom } from '../../components/Table';
import { NEWSLETTER_CONFIG_TABLE_KEYS, NEWSLETTER_RUN_FORM_DATA } from '../../helper';
import { toast } from 'react-toastify';
import FormRender from '../../components/FormRender';

const NewsletterStart = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [configs, setConfigs] = useState([]);
    const axiosInstance = useAxiosInstance();
    const [formData, setFormData] = useState({
        "config_pk": null,
        "is_industry_sourcing_on": false,
        "is_company_sourcing_on": false,
    });

    useEffect(() => {
        
        setIsLoading(true);
        axiosInstance
            .post("/newsletter/v2/all_configs/")
            .then((res) => {
                setIsLoading(false);
                const filtered = res?.data?.data?.filter(it=>it?.username?.includes('@wokelo.ai')||it?.username?.includes('@datacreek.org'));
                const sorted = filtered?.sort((a, b) => b.id - a.id);
                setConfigs(sorted);
            })
            .catch((err) => {
                setIsLoading(false);
            });
    }, []);


    return (
        <div className="w-full px-6">
            <div className="p-3 my-5 border rounded-lg bg-white w-full">
                <p className="text-2xl text-black font-medium mb-4 flex justify-between">Run Newsletter</p>

                <p className="text-sm font-semibold mt-4 mb-2">Select Config ({formData.config_pk})</p>
                <TableCustom
                    columns={NEWSLETTER_CONFIG_TABLE_KEYS}
                    data={{ 'data': configs }}
                    loading={isLoading}
                    handleEdit={null}
                    handleDelete={null}
                    handleSelect={(id) => {
                        const config = configs.find(it=>it.id === id)
                        console.log(config, configs)
                        if(config.no_of_themes>=3 && config.publish_state === 'Publish'){
                            setFormData({ ...formData, config_pk: id })
                            toast.success(`Config ${id} is selected`)
                        }else{
                            if(config.no_of_themes < 3){
                                toast.error(`Number of config is less then 3`)
                            }
                            if(config.publish_state !== 'Publish'){
                                toast.error(`Newsletter is not Published`)
                            }
                            setFormData({ ...formData, config_pk: null })    
                        }
                    }
                    }
                    className="h-[35vh] max-w-full"
                />
                <FormRender
                    formData={formData}
                    formSettings={NEWSLETTER_RUN_FORM_DATA}
                    setFormData={setFormData}
                />
                <button
                    className='px-3 py-1 mt-4 border text-white disabled:text-black bg-black rounded-lg text-sm disabled:bg-white  disabled:cursor-not-allowed '
                    disabled={isSaving}
                    onClick={() => {
                        const payload = { ...formData }
                        setIsSaving(true)
                        axiosInstance
                            .post("/newsletter/v2/sandbox_run_newsletter/", payload)
                            .then((res) => {
                                setIsSaving(false);
                                toast.success('Ran successfully!')
                            })
                            .catch((err) => {
                                setIsSaving(false);
                            });
                    }}>{isSaving ? 'loading..' : 'Run'}</button>
            </div>
        </div>
    )
}

export default NewsletterStart